import { branch, renderNothing } from 'recompose'

export default hideChecker => branch(hideChecker, renderNothing)
